import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';

export class RavelCircularSequence extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #container {
            position: relative;
            border: 10px solid #aaaaaa;
            border-radius: 50%;
            width: 480px;
            height: 480px;
            font-size: 48px;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
        <div id="cursor">⚫️</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        <div>🔴</div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'background', 'display-count', 'speed'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.width = 480;
        this.height = 480;
        this.centerX = this.width / 2;
        this.centerY = this.height / 2;
        this.cursorAngle = 0;
        this.cursorRadius = 180;
        this.cursorSpeed = 2000;
        this.displayCount = 16;
        this.elementRadius = 24;
        this.cursor = this.shadowRoot.querySelector('#cursor');
    }
  
    setup = () => {
        this.observedMessages = ['message'];
        //this.subscribe(this.observedMessages);   
        this.container.style.width = `${this.width}px`; 
        this.container.style.height = `${this.height}px`;
        for (let element of this.shadowRoot.querySelector('#container').children) {
            console.log(element);
            element.style.position = 'absolute';
            element.style.left = '0px';
            element.style.top = '0px';
            element.style['transform-origin'] = 'center'
            element.style.transform = `translate(-50%, -50%)`
        }
        this.updateDisplay();
        this.moveCursor();
    }
    
    teardown = () => {
       // this.unsubscribe(this.observedMessages);
    }

    updateDisplay = () => {
        console.log('update display');
        let children = this.shadowRoot.querySelector('#container').children;
        let anglePerDivision = 360 / this.displayCount;
        console.log(anglePerDivision);
        // cursor is always first child
        let angle = 0;
        for (let i = 1; i < children.length; i++) {
            if (i <= this.displayCount) {
                children[i].style.display = 'block';
                this.placeAtAngle(children[i], angle);
                angle += anglePerDivision;
            } else {
                children[i].style.display = 'none';
            }

        }
    }

    moveCursor = () => {
            this.cursorAngle += (2 * Math.PI) / this.cursorSpeed; // Update angle per frame (~60fps)
            const x = this.centerX + this.cursorRadius * Math.cos(this.cursorAngle);
            const y = this.centerY + this.cursorRadius * Math.sin(this.cursorAngle);
    
            this.cursor.style.left = `${x}px`;
            this.cursor.style.top = `${y}px`;
    
            requestAnimationFrame(this.moveCursor);
        }
    
    placeAtAngle = (element, angle) => {
        let radians = angle * Math.PI / 180;
        // this.centerX is the same as radius
        const x = this.centerX + (this.centerX +  + this.elementRadius / 4) * Math.cos(radians);
        const y = this.centerY + (this.centerX +  + this.elementRadius / 4) * Math.sin(radians);
        console.log(x + ' ' + y);
        element.style.left = `${x}px`;
        element.style.top = `${y}px`;
    }



    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'background') {
            this.background = newValue;
        }
        if (name === 'display-count') {
            this.displayCount = parseInt(newValue, 10);
            this.updateDisplay();
        }
        if (name === 'speed') {
            this.cursorSpeed = parseInt(newValue, 10);
        }
    }
}